export default __webpack_public_path__ + "static/media/stuck-in-the-middle-slope.8cf6352d.svg";